export default __webpack_public_path__ + "static/media/car_left.085172fe.png";